export const WEBHOOK_SETTINGS_API = '/api/dashboard/webhook/webhooks'
